import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-20ed754a"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "user-menu"
};
const _hoisted_2 = {
  class: "avatar"
};
const _hoisted_3 = {
  class: "user-name"
};
const _hoisted_4 = {
  class: "menu-list"
};

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "退出", -1));

const _hoisted_6 = {
  class: "icon"
};
import { ref } from 'vue';
import { ElMessage } from 'element-plus';
import useUserStore from '@/store/modules/user.js';
import { useRouter } from 'vue-router';
import { storeToRefs } from 'pinia';
import ExitIcon from '../icon/exit-icon.vue';
import UserIcon from '../icon/user-icon.vue';
export default {
  __name: 'user-menu',

  setup(__props, {
    expose: __expose
  }) {
    const userStore = useUserStore();
    const {
      userInfo
    } = storeToRefs(userStore);
    const router = useRouter();
    const drawerVisible = ref(false);

    const handleExitClick = () => {
      userStore.initUserExit();
      ElMessage({
        message: '退出登录成功！',
        type: 'success'
      });
      drawerVisible.value = false;
    };

    __expose({
      drawerVisible
    });

    return (_ctx, _cache) => {
      const _component_el_avatar = _resolveComponent("el-avatar");

      const _component_el_drawer = _resolveComponent("el-drawer");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_drawer, {
        modelValue: drawerVisible.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => drawerVisible.value = $event),
        "with-header": false,
        size: "200px",
        direction: "rtl"
      }, {
        default: _withCtx(() => {
          var _unref2;

          return [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_avatar, {
            size: "small",
            src: "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png"
          })]), _createElementVNode("div", _hoisted_3, _toDisplayString((_unref2 = _unref(userInfo)) === null || _unref2 === void 0 ? void 0 : _unref2.username), 1), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", {
            class: "menu-item",
            onClick: handleExitClick
          }, [_hoisted_5, _createElementVNode("div", _hoisted_6, [_createVNode(ExitIcon)])])])];
        }),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }

};